import $http from '@/libs/axios'

export default class IntegrationCategoriesAPI {
  static async update(payload: any) {
    return (await $http.post('/integrations/categories/update', payload)).data
  }

  static async list() {
    return (await $http.get('/integrations/categories/list')).data
  }
}
